import { ReactNode } from "react"
import { Button } from "@/components/ui/button"
import { Download } from "lucide-react"
import { cn } from "@/lib/utils"
import { usePWA, type PWAState } from "@/context/PWAContext"

export interface PWAInstallState extends PWAState {}

interface PWAInstallPromptProps {
    isCollapsed?: boolean
    className?: string
    children?: (state: PWAInstallState) => ReactNode
}

export function PWAInstallPrompt({ isCollapsed = false, className, children }: PWAInstallPromptProps) {
    const { isInstallable, isInstalled, handleInstall } = usePWA()

    const installState: PWAInstallState = {
        isInstallable,
        isInstalled,
        handleInstall
    }

    // If children render prop is provided, use it
    if (children) {
        console.log('PWAInstallPrompt: Using render prop for children')
        console.log('PWAInstallPrompt: Install state:', installState)
        return <>{children(installState)}</>
    }

    // Don't render if not installable or already installed
    if (!isInstallable || isInstalled) {
        console.log('PWAInstallPrompt: Not rendering - isInstallable:', isInstallable, 'isInstalled:', isInstalled)
        return null
    }

    console.log('PWAInstallPrompt: Rendering install button, isCollapsed:', isCollapsed)
    
    if (isCollapsed) {
        return (
            <Button
                variant="ghost"
                size="icon"
                onClick={handleInstall}
                className={cn("text-primary hover:text-primary hover:bg-primary/10", className)}
                aria-label="Install app"
            >
                <Download className="h-5 w-5" />
            </Button>
        )
    }

    return (
        <Button
            variant="outline"
            onClick={handleInstall}
            className={cn("w-full flex items-center justify-center space-x-2 text-primary border-primary hover:bg-primary hover:text-white", className)}
        >
            <Download className="h-4 w-4" />
            <span>Install App</span>
        </Button>
    )
}
